// Services/fetchRequestPasswordReset.js
import { USERS } from "../Constants/Endpoints";
import { ApiRequestInterceptor } from "./apiRequest";

export const fetchRequestPasswordReset = async (body) => {
  const method = "POST";
  const response = await ApiRequestInterceptor(USERS.requestPasswordReset, method, body);

  if (response.code === 200) {
    return { statusCode: 200, message: response.message || "Correo enviado con instrucciones" };
  }

  if (response.code === 404) {
    return { statusCode: 404, message: response.message || "Usuario no encontrado" };
  }

  return { statusCode: response.code || 500, message: response.message || "Error al solicitar recuperación" };
};